import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface Lead {
  id: string
  address: string
  name: string
  phone: string
  email: string
  date: string
  status: 'new' | 'contacted' | 'qualified' | 'archived'
}

interface LeadStore {
  leads: Lead[]
  addLead: (lead: Omit<Lead, 'id' | 'date' | 'status'>) => void
  updateLeadStatus: (id: string, status: Lead['status']) => void
  deleteLead: (id: string) => void
}

export const useLeadStore = create<LeadStore>()(
  persist(
    (set) => ({
      leads: [],
      addLead: (leadData) =>
        set((state) => ({
          leads: [
            {
              ...leadData,
              id: Math.random().toString(36).substring(2, 9),
              date: new Date().toISOString(),
              status: 'new',
            },
            ...state.leads,
          ],
        })),
      updateLeadStatus: (id, status) =>
        set((state) => ({
          leads: state.leads.map((lead) =>
            lead.id === id ? { ...lead, status } : lead,
          ),
        })),
      deleteLead: (id) =>
        set((state) => ({
          leads: state.leads.filter((lead) => lead.id !== id),
        })),
    }),
    {
      name: 'kareem-leads-storage-91311',
    },
  ),
)
